module.exports = __webpack_public_path__ + "static/img/home_header_logo_jinridui.3836477c.png";